

<ul class="page-links-holder" *ngIf="!unika">
<li *ngFor="let item of items | rankingNum: 'ranking'" class="page-link {{ item.additionalClass+'-link-holder' }}" [class.active]="selectedItem == item">
    <a (click)="listClick($event, item)" class="simulation-show" href="javascript:;">{{ item.LinkName }}</a>
</li>
</ul>
<ul class="holder-links" *ngIf="unika">
  <li *ngFor="let item of items | rankingNum: 'ranking'" class="page-link {{ item.additionalClass+'-link-holder' }}" [class.active]="selectedItem == item">
      <a (click)="listClick($event, item)" href="javascript:;">
        <div class="text"></div>
        <div *ngIf="this.currentLanguage === 'he'" class="title">{{ item.LinkName }}</div>
        <div *ngIf="this.currentLanguage === 'en'" class="title">{{ item.LinkNameEn }}</div>
        <lottie-player id="galleryLottie" class="lottie" *ngIf="outOfGalleryMenu"
        src="https://lottie.host/2c3ba93c-99fc-42db-844d-c3a6866c10d0/gKnraCUNeJ.json" background="transparent"
        speed="1" loop autoplay></lottie-player>
      </a>
  </li>
  </ul>

